import { useEffect, useRef, useState } from 'react'
import { postalCodes } from '../data/postalCodes'
import type { StepInputProps } from './StepInput'

export function PostnrInput({ state, onSubmit }: StepInputProps) {
  const [postnr, setPostnr] = useState(state.postnr ?? '')
  const [showSug, setShowSug] = useState(false)
  const [sug, setSug] = useState<[string, string][]>([])
  const ref = useRef<HTMLInputElement>(null)

  useEffect(() => { ref.current?.focus() }, [])

  const isValid = postnr.length === 4 && /^\d{4}$/.test(postnr)

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.replace(/\D/g, '').slice(0, 4)
    setPostnr(val)
    if (val.length >= 2) {
      const m = Object.entries(postalCodes).filter(([c]) => c.startsWith(val)).slice(0, 5)
      setSug(m)
      setShowSug(m.length > 0)
    } else {
      setShowSug(false)
    }
  }

  const select = (code: string, city: string) => {
    setPostnr(code)
    setShowSug(false)
    onSubmit({ postnr: code, by: city })
  }

  const submit = () => {
    if (!isValid) return
    const city = postalCodes[postnr] ?? 'dit område'
    onSubmit({ postnr, by: city })
  }

  return (
    <div className="input-dock">
      <div className="input-row">
        <div className="autocomplete-wrapper">
          <input
            ref={ref}
            type="text"
            className="input-field"
            placeholder="f.eks. 2100"
            maxLength={4}
            inputMode="numeric"
            autoComplete="postal-code"
            value={postnr}
            onChange={handleInput}
            onBlur={() => setTimeout(() => setShowSug(false), 150)}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
          />
          <div className={`autocomplete-suggestions ${showSug ? 'show' : ''}`}>
            {sug.map(([code, city]) => (
              <div
                key={code}
                className="suggestion-item"
                onMouseDown={() => select(code, city)}
              >
                <span className="city">{city}</span>
                <span className="postal">{code}</span>
              </div>
            ))}
          </div>
        </div>
        <button className="btn-send" onClick={submit} disabled={!isValid}>Send</button>
      </div>
    </div>
  )
}
